export default __webpack_public_path__ + "static/media/icon-google.27be8b46.svg";